/**
 * `TeamRosterTab` returns early for three states — loading, error, and "no
 * roster for this division" — and only the first ever mounts `RosterSection`,
 * which is the thing that reports capabilities. `OperationsTab` resets
 * capabilities to the LOADING state on every selection change, betting that
 * a report is coming; the error and no-roster branches never send one, so
 * without an explicit "stop" report the header's Add button would be stuck
 * on a skeleton forever for those nodes.
 *
 * Loading is excluded on purpose — the inherited loading state is already
 * correct there, and this component is not yet in a position to say whether
 * capabilities exist.
 */
export interface ShouldStopReportingRosterCapabilitiesArgs {
  isLoading: boolean
  isError: boolean
  /** Any truthy value once the roster resolves; only nullishness matters here. */
  roster: unknown
}

export const shouldStopReportingRosterCapabilities = ({
  isLoading,
  isError,
  roster,
}: ShouldStopReportingRosterCapabilitiesArgs): boolean => {
  if (isLoading) {
    return false
  }

  return isError || !roster
}
